// Время площадки (решение Анны: все нормы завода — по местному времени площадки отгрузки).
// TMS отдаёт время точек уже местным (без пояса); сервер добавляет точке поле timezone (IANA).
// Показываем местное время и рядом «(по Ульяновску ЧЧ:ММ)» — офис работает по Ульяновску.

export const ULYANOVSK = 'Europe/Ulyanovsk'

const NAIVE_RE = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/

function pad(n) {
  return String(n).padStart(2, '0')
}

// «2026-11-08T02:10:00» → { y, m, d, h, mi } без пересчёта поясов браузером.
export function parseNaive(value) {
  if (!value) return null
  const match = NAIVE_RE.exec(String(value))
  if (!match) return null
  const [, y, m, d, h, mi] = match.map(Number)
  return { y, m, d, h, mi }
}

function zoneParts(instantMs, timeZone) {
  const fmt = new Intl.DateTimeFormat('en-GB', {
    timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
    hourCycle: 'h23',
  })
  const out = {}
  for (const part of fmt.formatToParts(new Date(instantMs))) out[part.type] = part.value
  return { y: +out.year, m: +out.month, d: +out.day, h: +out.hour, mi: +out.minute }
}

function partsToUtcMs(p) {
  return Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi)
}

// Местное время площадки → момент времени (мс UTC).
export function wallToInstant(parts, timeZone) {
  const guess = partsToUtcMs(parts)
  let instant = guess
  for (let i = 0; i < 2; i += 1) {
    const offset = partsToUtcMs(zoneParts(instant, timeZone)) - instant
    instant = guess - offset
  }
  return instant
}

function validZone(timeZone) {
  if (!timeZone) return false
  try {
    new Intl.DateTimeFormat('en-GB', { timeZone })
    return true
  } catch (e) {
    return false
  }
}

function label(p, withDate) {
  const time = pad(p.h) + ':' + pad(p.mi)
  return withDate ? pad(p.d) + '.' + pad(p.m) + ' ' + time : time
}

// «05.11 08:00 (по Ульяновску 09:00)»; пояс неизвестен или совпадает с Ульяновском — без скобок.
export function formatPlaceTime(value, timeZone, { withDate = true } = {}) {
  const local = parseNaive(value)
  if (!local) return ''
  const text = label(local, withDate)
  if (!validZone(timeZone)) return text
  const uly = zoneParts(wallToInstant(local, timeZone), ULYANOVSK)
  if (uly.h === local.h && uly.mi === local.mi && uly.d === local.d) return text
  const sameDay = uly.d === local.d && uly.m === local.m
  return text + ' (по Ульяновску ' + label(uly, withDate && !sameDay) + ')'
}

export function isLoadingPoint(point) {
  const op = String(point?.operation_type || '').toLowerCase()
  return !op.includes('выгруз') && (op.includes('тгруз') || op.includes('погруз'))
}

export function firstLoading(points) {
  return (points || []).filter(isLoadingPoint)
    .sort((a, b) => String(a.planned_date || '').localeCompare(String(b.planned_date || '')))[0] || null
}

export function lastUnloading(points) {
  return (points || []).filter((p) => String(p?.operation_type || '').toLowerCase().includes('выгруз'))
    .sort((a, b) => String(a.planned_date || '').localeCompare(String(b.planned_date || ''))).at(-1) || null
}

// Плановое время точки: поправленное заводом главнее.
export function plannedOf(point) {
  return point ? (point.correct_planned_datetime || point.planned_date) : null
}

// Исход рейса для колонки «Причина»: «Отмена · в регламент», подсказка — объяснение системы.
const OUTCOME_SHORT = {
  factory_cancel: 'Отмена завода · в регламент',
  factory_late_cancel: 'Срыв заводу · вне регламента',
  breakdown_to_us: 'Срыв нам',
  carrier_refusal: 'Отказ ТК',
  offer_withdrawn: 'Снят с предложения',
}

export function outcomeLabel(trip) {
  if (trip?.outcome && OUTCOME_SHORT[trip.outcome]) return OUTCOME_SHORT[trip.outcome]
  return trip?.tms_response_code || ''
}

export function outcomeTone(trip) {
  if (trip?.outcome === 'factory_late_cancel' || trip?.outcome === 'breakdown_to_us') return 'bad'
  if (trip?.outcome) return 'neutral'
  return ''
}
